module.exports = __webpack_public_path__ + "static/bg2-b3e7e772a7d0af70e4572f649bc8b61e.jpg";